// extracted by mini-css-extract-plugin
export default {"wrap":"Center_wrap__VneyF","inner":"Center_inner__cc8ey"};